<template>
  <div>
    <div v-if="loading" class="md-layout">
      <div class="md-layout-item md-size-100 box-carregando">
        <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate">{{msg_status}}</md-progress-spinner>
      </div>
    </div>

    <div
      v-if="!loading"
      class="box-dashboard"
      v-match-heights="{ el: ['.boxHeight', '.boxHeight2']}"
    >
      <div class="md-layout">
        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>edit</md-icon>
              </div>
              <h4 class="title">Última Nota</h4>
            </md-card-header>
            <md-card-content class="boxHeight flex-center">
              <div class="box-valor" v-if="result.ultima_nota != null ">
                <!--
                Se a Nota for abaixo de "8" inserir a class "low" nesse H1 para ficar em vermelho
                Fazer a mesma coisa no relatório interno, está imprimindo tudo vermelho "low". Também tem uma class lá "null" caso tiver alguma nota nula.
                -->
                <h1
                  :class="result.ultima_nota.classNota"
                >{{result.ultima_nota.nota_final | nota_final_show }}</h1>
                <h5>Nota da última Auditoria Técnica</h5>
              </div>
            </md-card-content>
            <md-card-actions>
              <md-button
                class="md-success md-block"
                v-on:click="visualizar(result.ultima_nota)"
              >Visualizar</md-button>
            </md-card-actions>
          </md-card>
        </div>

        <div class="md-layout-item md-size-50 md-small-size-100">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>update</md-icon>
              </div>
              <h4 class="title">Últimas Auditorias</h4>
            </md-card-header>
            <md-card-content class="boxHeight">
              <div class="box-table" v-if="result.ultimas != null">
                <!--
                Mostrar 5 itens apenas
                Inserir a class "Low" no span, apenas se for abaixo de 8, caso contrário deixar apenas o span "vai ficar azul"
                -->
                <md-table v-model="result.ultimas" class="table-responsive">
                  <md-table-row slot="md-table-row" slot-scope="{ item }">
                    <md-table-cell
                      md-label="Unidade"
                      md-sort-by="nome_estabelecimento"
                    >{{ item.nome_estabelecimento }}</md-table-cell>
                    <md-table-cell md-label="Data" md-sort-by="data">{{ item.data | date_show }}</md-table-cell>
                    <md-table-cell md-label="Resultado" md-sort-by="nota_final">
                      <span :class="item.classNota">{{ item.nota_final | nota_final_show}}</span>
                    </md-table-cell>
                  </md-table-row>
                </md-table>
              </div>
            </md-card-content>
            <md-card-actions>
              <md-button class="md-success md-block" v-on:click="redirect()">Visualizar</md-button>
            </md-card-actions>
          </md-card>
        </div>

        <div class="md-layout-item md-size-50 md-xsmall-size-100" v-if="result.auditorias != null">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>home</md-icon>
              </div>
              <h4 class="title">Unidades com Não Conformidades recorrentes</h4>
            </md-card-header>
            <md-card-content class="boxHeight2 flex-center">
              <div class="box-valor">
                <h1 class="low">{{result.auditorias.qtde_unidades_recorrentes}}</h1>
                <h6>de {{result.auditorias.total}} unidades</h6>
                <h5>Total de recorrência de Não Conformidades em Auditorias</h5>
              </div>
            </md-card-content>
          </md-card>
        </div>

        <div class="md-layout-item md-size-50 md-xsmall-size-100" v-if="result.auditorias != null">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>thumb_down</md-icon>
              </div>
              <h4 class="title">Total de Não Conformidades recorrentes</h4>
            </md-card-header>
            <md-card-content class="boxHeight2 flex-center">
              <div class="box-valor">
                <h1 class="low">{{result.auditorias.qtde_item_recorrentes}}</h1>
                <h6>em {{result.auditorias.total}} unidades</h6>
                <h5>Total de recorrência de Não Conformidades em Auditorias</h5>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <modal v-if="show_modal" @close="closeModal()" class="md-size-75">
      <div slot="header">Mídia / Arquivos</div>
      <div slot="body">
        <inspecao_visualizar
          v-if="form != null"
          v-bind:cliente_oculto="cliente_oculto"
          v-bind:id_load="form.id"
          show_back_button="false"
        ></inspecao_visualizar>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import VueMatchHeights from "vue-match-heights";
import service from "../../../services/DashBoardService";
import modal from "../../../components/Modal";
import inspecao_visualizar from "../auditoria/Visualizar";

Vue.use(VueMatchHeights, {
  disabled: [961]
});

export default {
  name: "TableFixed",
  components: {
    modal,
    inspecao_visualizar
  },
  data: () => ({
    loading: false,
    msg_status: "Carregando..",
    result: {},
    show_modal: false,
    form: null,

    auditorias: [
      {
        unidade:
          "GAP-AN (GAP) - ALA 2 - Antiga BAAN (Base aérea de Anápolis) / Anápolis - GO",
        data: "14/05/2019",
        resultado: "8,68",
        class: "low"
      },
      {
        unidade: "GAP-BR (GAP) - GAP BR / Brasilia - DF",
        data: "08/05/2019",
        resultado: "8,46"
      },
      {
        unidade: "GAP-SM (GAP) ALA 4 (Antiga BASM-Base Aérea de Santa Maria)",
        data: "07/05/2019",
        resultado: "7,04"
      },
      {
        unidade:
          "GAP-AN (GAP) - ALA 2 - Antiga BAAN (Base aérea de Anápolis) / Anápolis - GO",
        data: "05/05/2019",
        resultado: "8,68"
      },
      {
        unidade:
          "GAP-AN (GAP) - ALA 2 - Antiga BAAN (Base aérea de Anápolis) / Anápolis - GO",
        data: "05/05/2019",
        resultado: "8,68"
      }
    ]
  }),
  mounted() {
    var self = this;
    self.loading = true;

    service.getIndexCliente().then(function(response) {
      self.loading = false;
      self.result = response.data.data;
    });
  },
  methods: {
    closeModal() {
      this.show_modal = false;
    },
    visualizar(item) {
      this.form = item;
      this.show_modal = true;
    },
    redirect() {
      //{ name: item.name, path: item.path , icon: item.icon }

      this.$router.push({ path: "/area/auditoria" });
    }
  }
};
</script>